import { AreaGroup, SitemapItem } from '@msdk/definitions'
import { selector, selectorFamily } from 'recoil'

import { $apiClient } from '../core'

const sortMapItem = (a: SitemapItem, b: SitemapItem) => {
  if (a.position < b.position) return -1
  if (a.position > b.position) return 1
  if (a.id < b.id) return -1
  if (a.id > b.id) return 1
  return 0
}

const sortArea = (area: AreaGroup) => {
  area.items.sort(sortMapItem)

  area.items.forEach((i) => {
    if (i.type === 'AreaGroup') {
      sortArea(i as AreaGroup)
    }
  })
}

export const $sitemap = selectorFamily({
  key: 'SitemapModel',
  get:
    (sitemapName: string) =>
    async ({ get }) => {
      const client = get($apiClient)
      const sitemap = await client.metadata.getSiteMap(sitemapName)
      sitemap.areas.sort(sortMapItem)

      sitemap.areas.forEach((a) => {
        sortArea(a)
      })
      return sitemap
    },
})

export const $sitemapItems = selector({
  key: 'SitemapItems',
  get: async ({ get }) => {
    const client = get($apiClient)
    const items = await client.metadata.getSitemapItems()
    return items
  },
})
